module.exports = __webpack_public_path__ + "img/IMG-20200310-WA0043.55ed510c.jpg";